import { Wallpaper } from './components/wallpaper/wallpaper';
import { ContentTracking } from './components/content-tracking/content-tracking';
import { Tracking } from './tracking';
import { GenericFootnotes } from './components/generic-footnotes/generic-footnotes';

init();

export function init() {
    const tracking = new Tracking();

    const components = [new ContentTracking(tracking), new GenericFootnotes(tracking), new Wallpaper(tracking)];

    window.o_global.eventQBus.on('ft5.richContent.variationChanged', async ({ moin, productId, variationId, eventMergeId }) => {
        tracking.variationChanged(moin, productId, variationId, eventMergeId);
        components.forEach((component) => {
            component.variationChanged();
        });
    });
}
